import "./Login.scss";

import React from "react";

import Frame from "../Frame/Frame";
import { STORE_AUTH } from "../../Store/AuthStore";
import { observer, inject } from "mobx-react";
import { Route } from "react-router5";
import { ROUTE_PROCESSED_QUALITIES, ROUTE_TABLE } from "../../routes";
import { STORE_CONFIG } from "../../Store/ConfigStore";
import { login } from "../../utility";
import { instanceOf } from "prop-types";
import {
  CookiesProvider,
  withCookies,
  Cookies,
  useCookies,
} from "react-cookie";

@inject((stores) => ({
  store: stores.store.get(STORE_AUTH),
  configStore: stores.store.get(STORE_CONFIG),
  socket: stores.socket,
}))
@observer
class LoginComponent extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { error: false };
  }

  componentDidMount() {
    this.props.store.setEmail("");
    this.props.store.setPin("");
  }

  onChangeEmail = (e) => {
    this.props.store.setEmail(e.target.value);
    this.setState({ error: false });
  };
  onChangePin = (e) => {
    this.props.store.setPin(e.target.value);
    this.setState({ error: false });
  };
  onPinKeyPress = (e) => {
    if (e.key === "Enter") {
      this.onClickLogin();
    }
  };
  onClickLogin = () => {
    const { store, configStore, socket, router, cookies } = this.props;

    socket.emit(
      "Login",
      {
        Email: store.email,
        Pin: store.pin,
      },
      (err, data) => {
        if (err) {
          console.error(err);
          store.setUser(null);
        } else {
          store.setUser(data);
          cookies.set("logicort-user", data, { expires: new Date() });
        }
        const user = data;
        if (store.token) {
          socket.emitWithToken("GetBaseData", {}, (err, data) => {
            if (err) {
              console.error(err);
              return;
            }
            configStore.setData(data);
            let route;
            switch (user.PermissionLevel) {
              case 10:
              case 11:
                route = ROUTE_PROCESSED_QUALITIES;
                break;
              default:
                route = ROUTE_TABLE;
                break;
            }
            router.navigate(route);
          });
        } else {
          this.onChangePin({ target: { value: "" } });
          this.setState({ error: true });
        }
      }
    );
  };

  render() {
    const { store } = this.props;
    const errorClassname =
      "error-message" + (!this.state.error ? " hidden" : "");
    return (
      <Frame>
        <div className="login basic-content">
          <div className="login__form">
            <div className="form-row login__email">
              <label className="form-label" htmlFor="login__email-input">
                Felhasználónév
              </label>
              <input
                id="login__email-input"
                type="email"
                className="login__input-row form-input"
                value={store.email}
                onChange={this.onChangeEmail}
              />
            </div>
            <div className="form-row login__pin">
              <label className="form-label" htmlFor="login__pin-input">
                Jelszó
              </label>
              <input
                id="login__pin-input"
                type="password"
                className="login__input-row form-input"
                value={store.pin}
                onChange={this.onChangePin}
                onKeyPress={this.onPinKeyPress}
              />
            </div>
            <div className="login__button">
              <div className="btn btn--block" onClick={this.onClickLogin}>
                Belépés
              </div>
            </div>
            <div className={errorClassname}>Hibás felhasználónév vagy PIN.</div>
          </div>
        </div>
      </Frame>
    );
  }
}

const Login = (props) => (
  <Route>
    {(routerProps) => <LoginComponent {...routerProps} {...props} />}
  </Route>
);

export default withCookies(Login);
